export const environment = {
  production: true,
  buildId: '2689626003218451',
  configFile: 'config.json',
};
